import React, { useState } from 'react';
import { AlertCircle } from 'lucide-react';
import authServiceAdmin from '../authServiceAdmin';
import { useAdmin } from '../context/AdminContext';

export default function RegisterPage() {
  const { setCurrentAdmin, setIsAuthenticated, setCurrentPage } = useAdmin();
  const [formData, setFormData] = useState({ name: '', email: '', password: '', confirmPassword: '', secretCode: '' });
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!formData.secretCode) { setError('Le code secret est requis'); return; }
    if (formData.password !== formData.confirmPassword) { setError('Les mots de passe ne correspondent pas'); return; }
    if (formData.password.length < 8) { setError('Le mot de passe doit contenir au moins 8 caractères'); return; }
    if (!formData.email.includes('@')) { setError('Email invalide'); return; }
    setIsSubmitting(true);
    try {
      const result = await authServiceAdmin.register({ name: formData.name, email: formData.email, password: formData.password, secretCode: formData.secretCode });
      if (result.success) {
        setCurrentAdmin(result.user);
        setIsAuthenticated(true);
        setCurrentPage('dashboard');
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError("Erreur lors de l'inscription: " + err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  return (
    <div className="auth-page-admin">
      <div className="auth-container-admin">
        <div className="auth-card-admin">
          <div className="auth-logo"><img src="/logo192.png" alt="Mbiyo" style={{ width: 56, height: 56, objectFit: 'contain' }} /></div>
          <h1>Mbiyo Admin</h1>
          <h2>Créer un compte Administrateur</h2>
          {error && (
            <div className="error-message"><AlertCircle size={18} />{error}</div>
          )}
          <form onSubmit={handleRegister}>
            <div className="form-group">
              <label>Nom complet</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Jean Mukendi" required />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="admin@mbiyo.org" required />
            </div>
            <div className="form-group">
              <label>Code Secret 🔐
                <span style={{ color: '#DC2626', fontSize: '0.875rem', marginLeft: '0.5rem' }}>(Requis pour créer un compte admin)</span>
              </label>
              <input type="password" name="secretCode" value={formData.secretCode} onChange={handleChange} placeholder="Entrez le code secret" required style={{ fontFamily: 'monospace', letterSpacing: '2px', fontSize: '1.1rem' }} />
            </div>
            <div className="form-group">
              <label>Mot de passe</label>
              <input type="password" name="password" value={formData.password} onChange={handleChange} placeholder="Au moins 8 caractères" required />
            </div>
            <div className="form-group">
              <label>Confirmer le mot de passe</label>
              <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder="Répétez le mot de passe" required />
            </div>
            <button type="submit" className="btn-auth-admin" disabled={isSubmitting}>
              {isSubmitting ? '⏳ Inscription en cours...' : 'Créer mon compte'}
            </button>
          </form>
          <p className="auth-switch">
            Déjà un compte ?{' '}
            <span onClick={() => setCurrentPage('login')}>Se connecter</span>
          </p>
        </div>
      </div>
    </div>
  );
}
